import { useCallback } from "react";
import { OptionalFieldGroup } from "./FieldGroup";

interface EnableNewMessageSoundProps {
  enabled?: boolean;
  onChange: (enabled: boolean) => void;
}

export function EnableNewMessageSound({
  enabled = false,
  onChange,
}: EnableNewMessageSoundProps) {
  const handleChange = useCallback(
    (nextValue: boolean) => {
      onChange(nextValue);
    },
    [onChange]
  );

  return (
    <OptionalFieldGroup
      label={"Enable New Message Sound"}
      description={"Play a sound when a new agent message arrives."}
      enabled={enabled}
      toggleEnabled={handleChange}
    />
  );
}
